import { c as _c } from "react/compiler-runtime";
import React, { type SVGProps } from 'react';
export const MoreVerticalIcon = React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => {
  const $ = _c(6);
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M12 4.8579C11.5169 4.8579 11.1253 5.2495 11.1253 5.7326C11.1253 6.2157 11.5169 6.6074 12 6.6074C12.4831 6.6074 12.8747 6.2157 12.8747 5.7326C12.8747 5.2495 12.4831 4.8579 12 4.8579Z" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />;
    t1 = <path d="M12 10.9806C11.5169 10.9806 11.1253 11.3722 11.1253 11.8553C11.1253 12.3384 11.5169 12.73 12 12.73C12.4831 12.73 12.8747 12.3384 12.8747 11.8553C12.8747 11.3722 12.4831 10.9806 12 10.9806Z" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />;
    t2 = <path d="M12 17.10408C11.5169 17.10408 11.1252 17.4957 11.1252 17.9788C11.1252 18.46189 11.5169 18.85352 12 18.85352C12.4831 18.85352 12.8747 18.46189 12.8747 17.9788C12.8747 17.4957 12.4831 17.10408 12 17.10408Z" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] !== props || $[4] !== ref) {
    t3 = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props} ref={ref}>{t0}{t1}{t2}</svg>;
    $[3] = props;
    $[4] = ref;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
});
export default MoreVerticalIcon;